export const COLORS = {
    CANDIDATES: {
        BAWUMIA: '#0100e6',
        KEN: '#ff1a1a',
        BRYAN: '#fcd902',
        ADUTWUM: '#68006E',
        AGYEI: '#065419',
        OTHERS: '#5E3503'
    },
    LEGEND: {
        LEVEL_1: '#b3cde0',
        LEVEL_2: '#6497b1',
        LEVEL_3: '#005b96',
        LEVEL_4: '#03396c',
        LEVEL_5: '#011f4b'
    },

    WINNER_LEGEND_COLORS_SHADES: {
        BAWUMIA: {
            COLOR: '#0100e6',
            COLOR_LOW: '#7070f6ff',
            COLOR_MEDIUM: '#4e4dff',

        },
        KEN: {
            COLOR: '#ff1a1a',
            COLOR_LOW: '#ff8080',
            COLOR_MEDIUM: '#ff4d4d',

        },
        BRYAN: {
            COLOR: '#fcd902',
            COLOR_LOW: '#fee64d',
            COLOR_MEDIUM: '#fff299',
        },
        ADUTWUM: {
            COLOR: '#68006E',
            COLOR_LOW: '#AB00AB',
            COLOR_MEDIUM: '#F10BEB',
        },
        AGYEI: {
            COLOR: '#065419',
            COLOR_LOW: '#589B5A',
            COLOR_MEDIUM: '#A2E8A2',
        },
        OTHERS: {
            COLOR: '#5E3503',
            COLOR_LOW: '#AF7B49',
            COLOR_MEDIUM: '#FFCA93',
        },
    }
}
